<template>
  <div class="login-container">
    <!-- 背景图案区域 -->
    <div class="login-background">
      <div class="title">
        <h1 class="main-title">
          <img v-if="globalData.nationalFlagImg" class="logo-img" :src="globalData.nationalFlagImg" alt="">
          <span>{{ topTitle }}</span>
        </h1>
        <p>{{ subtitle }}</p>
      </div>

      <!-- 示意图区域，使用背景色代替 -->
      <div class="illustration-area" :style="loginImg ? { backgroundImage: `url('${loginImg}')` } : {}"></div>
    </div>
    <!-- 登录表单区域 -->
    <div class="login-form">
      <van-form @submit="onSubmitFn">
        <div class="form-item">
          <!-- <div class="label required">{{ $t('form.userName') }}</div> -->
          <div class="label required">User Name</div>
          <van-field
            v-model="formLogin.username"
            placeholder=""
            name="username"
            class="custom-field"
            :rules="[{ required: true, message: 'Required' }]"
          />
        </div>
        <div class="form-item">
          <!-- <div class="label required">{{ $t('form.password') }}</div> -->
          <div class="label required">Password</div>
          <van-field
            v-model="formLogin.password"
            placeholder=""
            type="password"
            name="password"
            class="custom-field"
            :rules="[{ required: true, message: 'Required' }]"
          />
        </div>
        <div class="submit-btn">
          <!-- :loading-text="$t('shared.loading')" -->
          <van-button :loading="isLoading" round block type="info" native-type="submit" loading-text="Loading...">
            Login
            <!-- {{ $t('button.login') }} -->
          </van-button>
        </div>
        <!-- <van-field
          v-model="formLogin.username"
          name="username"
          label="username"
          placeholder=""
          :rules="[{ required: true, message: 'username is required' }]"
        />
        <van-field
          v-model="formLogin.password"
          type="password"
          name="password"
          label="password"
          placeholder=""
          :rules="[{ required: true, message: 'password is required' }]"
        />
         -->
      </van-form>
    </div>
  </div>
</template>

<script>

import { Notify } from 'vant'
import { mapActions, mapMutations, mapState } from 'vuex'
import { encrypt } from '@/utils/rsaEncrypt'
import { configLabelList } from '@/api/login'
// import i18n from '@/i18n/index.js'
export default {
  name: 'Login',
  data () {
    return {
      isLoading: false, // 登录的加载状态，false 没有加载，true表示加载中
      // 校验规则
      rules: {
        // 手机号的规则
        username: [
          {
            // 1. 必填
            required: true,
            message: this.$t('tips.usernameIsRequired'),
            trigger: 'onChange'
          }
        ],
        // 验证码的规则
        password: [
          {
            // 1. 必填
            required: true,
            message: this.$t('tips.passwordIsRequired'),
            trigger: 'onChange'
          }
        ]
      },
      // 登录表单数据
      formLogin: {
        // 手机号
        username: '',
        // 验证码
        password: '' // 默认只能用246810后台规定了
      },
      topTitle: 'ROS', // this.$t('shared.title.ros'),
      subtitle: 'Retail Operation System', // this.$t('shared.title.retailOperationSystem'),
      loginImg: ''
    }
  },
  created () {
    this.getProjectInfo()
  },
  activated () {
    if (window.localStorage.getItem('sampleDelivery')) {
      window.localStorage.removeItem('sampleDelivery')
    }
    if (window.localStorage.getItem('materialDelivery')) {
      window.localStorage.removeItem('materialDelivery')
    }
    if (window.localStorage.getItem('sdStoreSelect')) {
      window.localStorage.removeItem('sdStoreSelect')
    }
    if (window.localStorage.getItem('currentLang')) {
      window.localStorage.removeItem('currentLang')
    }
    this.getProjectInfo()
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  methods: {
    ...mapActions(['asyncLoginAction']),
    ...mapMutations(['setGlobalData']),
    // 登录按钮的 提交事件 - 只有全部通过校验了才会执行这个函数
    async onSubmitFn () {
      this.isLoading = true
      // 发送请求
      try {
        await this.asyncLoginAction({
          username: this.formLogin.username,
          password: encrypt(this.formLogin.password),
          // 获取时区：浏览器继承手机时区
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        })
        Notify({ type: 'success', message: this.$t('tips.loginSuccess'), duration: 1500 })
        // i18n.locale = process.env.VUE_APP_LANG
        this.$router.replace({
          // 登录成功，如果有from表示从这个路径调过来，那么就要让登录成功去这个地址，否则就去首页
          path: '/homePage'
          // path: this.$route.query.from || '/layout'
        })
      } catch (err) {
        console.log('err', err)
        Notify({ type: 'danger', message: this.$t('tips.accountOrPasswordIncorrect'), duration: 1500 })
      } finally {
        // 这里不管登录成功还是失败，都要将按钮解禁
        this.isLoading = false
      }
    },
    getProjectInfo () {
      configLabelList().then(res => {
        const projectInfo = []
        Object.keys(res.data).forEach(subItem => {
          projectInfo.push({ key: subItem, val: res.data[subItem] })
        })
        this.setGlobalData(projectInfo)
        if (res.data.loginImg) {
          this.loginImg = res.data.loginImg
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  min-height: 100vh;
  background: #fff;
  position: relative;

  .login-background {
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #fff;
  }

  .title {
    width: 100%;
    padding: 20px 0;
    background-color: #307bff;
    text-align: center;

    h1 {
      font-size: 28px;
      margin: 0;
      font-weight: bold;
    }
    .main-title {
      display: flex;
      align-items: center;
      justify-content: center;
      .logo-img {
        width: 34px;
        // height: 20px;
        margin-right: 5px;
      }
    }

    p {
      font-size: 14px;
      margin: 8px 0 0;
      opacity: 0.9;
    }
  }

  .illustration-area {
    position: relative;
    z-index: 99;
    width: 360px;
    height: 240px;
    object-fit: contain;
    margin-top: 21px;
    // background-image: url("~@/assets/images/Digital_Marketing_Strategy.svg");  /* 可以替换成实际的图片路径 */
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .login-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // left: 20px;
    // right: 20px;
    padding-top: 46px;
    background: #fff;
    // padding: 20px;
    // border-radius: 12px;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    .form-item {
      width: 300px;
      font-size: 14px;
      font-weight: 700;
      .label {
        margin-bottom: 6px;
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 8px;
        &::placeholder {
          color: #999;
        }
      }
    }
  }

  /* Vant 组件样式覆盖 */
  :deep(.van-field) {
    margin-bottom: 16px;
  }

  :deep(.van-cell) {
    padding: 10px 16px;
    border: 1px solid #ebedf0;
    border-radius: 8px;
    margin-bottom: 16px;
  }

  .submit-btn {
    margin-top: 24px;
  }

  :deep(.van-button--info) {
    background-color: #307bff;
    border: none;
    height: 44px;
    font-size: 16px;
  }

  /* 移除 Vant 默认边框 */
  :deep(.van-cell::after) {
    display: none;
  }
}
</style>
